<template>
  <div
    class="h-full overflow-y-auto portal-container overflow-x-hidden homepage-index bg-no-repeat"
  >
    <iframe
      v-if="type === 'application/pdf'"
      :src="`/lib/pdfjs/web/viewer.html?file=${pdfUrl}`"
      frameborder="0"
      class="w-full h-0px"
      ref="pdfView"
      @load="pdfViewOnload"
    ></iframe>
    <div
      v-if="type === 'image/png' || type === 'image/jpeg'"
      class="w-full h-full flex justify-center items-center"
    >
      <el-image :src="`${fileUrl}image/${attachmentsId}`">
        <div slot="error" class="image-slot">
          <i class="el-icon-picture-outline"></i>
        </div>
      </el-image>
    </div>
    <div v-if="type === 'video/mp4'" class="w-full h-full flex justify-center items-center">
      <video style="width: 80%;height:500px;" class="mx-auto" :src="videoSrc" controls></video>
    </div>
  </div>
</template>

<script>
import { EafTenantApi } from '@wiz-api/eaf-tenant-management'

const eafTenantApi = new EafTenantApi()
export default {
  computed: {
    type() {
      return this.$route.query.contentType
    },
    attachmentsId() {
      return this.$route.query.fileId
    },
    fileName() {
      return this.$route.query.fileName
    },
    videoUrl() {
      const fileServer = Wiz.GetModuleServer('file-management')
      return `${fileServer}/api/file-management/files/`
    },
    fileUrl() {
      const fileServer = Wiz.GetModuleServer('file-management')
      return `${fileServer}/api/file-management/files/public/`
    },
    pdfUrl() {
      return encodeURIComponent(
        `${this.fileUrl}preview/${this.attachmentsId}?contentType=application/pdf`
      )
    },
  },
  watch: {
    type: {
      immediate: true,
      handler(val) {
        if (val) {
          switch (this.type) {
            case 'video/mp4':
              this.handleVideo(this.$route.query.fileId)
              break
            default:
              break
          }
        }
      },
    },
    fileName: {
      immediate: true,
      async handler(val) {
        if (val) {
          const { config } = Wiz.globalSettings.dynamicModules.modules['portal-homepage-nanhai']
          document.title = `${this.$route.query.fileName} - ${config.title}`
          const { tenantName } = Wiz.globalSettings.globalConfig
          if (!tenantName) return
          const [err, res] = await eafTenantApi.getPublishByTenantName({ name: tenantName })
          if (!err && res.detail) {
            // 未登录状态下没有缓存企业信息，需手动设置icon
            document.querySelector("link[rel='icon']").href = `${this.fileUrl}${res.detail.icon}`
          }
        }
      },
    },
  },
  data() {
    return {
      imgSrc: '',
      videoSrc: '',
    }
  },
  methods: {
    pdfViewOnload() {
      const contentWindow = this.$refs.pdfView.contentWindow
      const contentDocument = contentWindow.document
      setTimeout(() => {
        const resetFunction = (e) => {
          if (e.pageNumber === contentWindow.PDFViewerApplication.pagesCount) {
            let maxWidth = contentDocument.body.offsetWidth
            _.forEach(contentDocument.getElementsByClassName('page'), (item) => {
              const actualWidth =
                item.offsetWidth / contentWindow.PDFViewerApplication.toolbar.pageScale
              if (actualWidth > maxWidth) {
                maxWidth = actualWidth
              }
            })
            contentWindow.PDFViewerApplication.eventBus.dispatch('scalechanged', {
              source: contentWindow.PDFViewerApplication.toolbar,
              value: _.round(contentDocument.body.offsetWidth / maxWidth, 2),
            })
            this.$refs.pdfView.style.height = `${contentDocument.getElementById('viewer')
              .offsetHeight + 100}px`
            contentWindow.PDFViewerApplication.eventBus.off('textlayerrendered', resetFunction)
          }
        }
        contentWindow.PDFViewerApplication.eventBus.on('textlayerrendered', resetFunction)
      }, 100)
      // 调整pdf预览样式颜色与主题色一致
      contentDocument.body.style.backgroundColor = 'unset'
      contentDocument.getElementById('toolbarContainer').style.backgroundImage = 'unset'
      contentDocument.getElementById('toolbarContainer').style.backgroundColor = '#c11920'
      contentDocument.getElementById('toolbarSidebar').style.backgroundColor = '#c11920'
      contentDocument.getElementById('toolbarSidebar').style.backgroundImage = 'unset'
      contentDocument.getElementById('findbar').style.backgroundColor = '#c11920'
      contentDocument.getElementById('findbar').style.backgroundImage = 'unset'
      contentDocument.getElementById('secondaryToolbar').style.backgroundColor = '#c11920'
      contentDocument.getElementById('secondaryToolbar').style.backgroundImage = 'unset'
      const selectOptions = contentDocument.querySelectorAll(
        '.dropdownToolbarButton > select > option'
      )
      if (selectOptions) {
        selectOptions.forEach((item) => {
          item.style.backgroundColor = '#c11920'
        })
      }
      const timer = setInterval(() => {
        if (contentWindow.PDFViewerApplication.pdfDocument) {
          clearInterval(timer)
          this.$refs.pdfView.style.height = `${contentDocument.getElementById('viewer')
            .offsetHeight + 100}px`
          setTimeout(() => {
            this.$refs.pdfView.style.height = `${contentDocument.getElementById('viewer')
              .offsetHeight + 100}px`
          }, 500)
          // 缩小
          contentDocument.getElementById('zoomIn').onclick = () => {
            this.$refs.pdfView.style.height = `${contentDocument.getElementById('viewer')
              .offsetHeight + 100}px`
          }
          // 放大
          contentDocument.getElementById('zoomOut').onclick = () => {
            this.$refs.pdfView.style.height = `${contentDocument.getElementById('viewer')
              .offsetHeight + 100}px`
          }
          // 缩放下拉切换
          contentDocument.getElementById('scaleSelect').onchange = () => {
            this.$refs.pdfView.style.height = `${contentDocument.getElementById('viewer')
              .offsetHeight + 100}px`
          }
        }
      }, 500)
      // if (!this.detailInfo.isAllowDownload) {
      //   contentDocument.querySelector('.toolbarButton.download').style.display = 'none'
      //   contentDocument.querySelector('.toolbarButton.print').style.display = 'none'
      // }
    },
    handleVideo(videoFileId) {
      this.videoSrc = `${this.videoUrl}${videoFileId}/play-video`
    },
  },
}
</script>

<style lang="scss" scoped></style>
